import { useTranslation } from "react-i18next";

import { Button } from "@/components/Interface/Button/Button";
import { FCC } from "@/types";

interface Props {
  onBack: () => void;
}

export const MagicLinkEmailSent: FCC<Props> = ({ onBack }) => {
  const { t } = useTranslation();

  return (
    <div
      className="max-w-[420px] md:m-auto md:h-max md:w-full"
      data-testid="magic-link-email-sent"
    >
      <p className="mb-10 text-lg text-white">
        {t("translation:newWelcome.magicLink.sent.message")}
      </p>

      <Button
        fullWidth
        className="accent"
        type="button"
        onClick={onBack}
        dataTestid="magic-link-email-sent-back"
      >
        {t("translation:newWelcome.magicLink.sent.backButton")}
      </Button>
    </div>
  );
};
